import { render, staticRenderFns } from "./trip_history.vue?vue&type=template&id=b0720c4a&scoped=true"
import script from "./trip_history.vue?vue&type=script&lang=js"
export * from "./trip_history.vue?vue&type=script&lang=js"
import style0 from "./trip_history.vue?vue&type=style&index=0&id=b0720c4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0720c4a",
  null
  
)

export default component.exports